import { render, staticRenderFns } from "./RoomLaundry.vue?vue&type=template&id=5e702a16&scoped=true"
import script from "./RoomLaundry.vue?vue&type=script&lang=ts"
export * from "./RoomLaundry.vue?vue&type=script&lang=ts"
import style0 from "./RoomLaundry.vue?vue&type=style&index=0&id=5e702a16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e702a16",
  null
  
)

export default component.exports